export default __webpack_public_path__ + "static/media/auditWHD.67efb6f6.svg";